module.exports = __webpack_public_path__ + "media/images/flags/NR-b309fdba59ccb14d7459bfd1c26b4c87.svg";